(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/views/betslip/betslip-payoptions.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/views/betslip/betslip-payoptions.js'); 'use strict';

svs.maltipset.views.BetslipPayOptions = Backbone.Marionette.View.extend({
  regions: {
    sportkryss: '.sportkryss',
    weeks: '.weeks'
  },
  events: {
    'click @ui.overviewButton': 'toggleOverviewBtn'
  },
  ui: {
    overviewButton: '.betslip-overview'
  },
  template: function template(data) {
    return svs.maltipset.templates.betslip_payoptions(data);
  },
  initialize: function initialize() {
    this.onAccountChange = this.onAccountChange.bind(this);
    if (svs.components.marketplace && svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.onAccountChange)) ;
  },
  onAccountChange: function onAccountChange(_ref) {
    var currentAccount = _ref.currentAccount;

    if (currentAccount) {
      this.options.coupon.updateNumWeeks(1);

      if (this.getRegion('weeks')) {
        this.getRegion('weeks').empty();
      }

      if (!svs.core.detect.feature('ft-marketplace-sportkryss') && this.getRegion('sportkryss')) {
        this.getRegion('sportkryss').empty();
      }

      this.options.betslip.doResize();
    } else {
      if (this.getRegion('weeks')) {
        this.getRegion('weeks').show(new svs.maltipset.views.BetslipContentWeeks({
          model: new svs.maltipset.models.Betslip({
            coupon: this.options.coupon
          })
        }));
      }

      if (!svs.core.detect.feature('ft-marketplace-sportkryss') && this.getRegion('sportkryss')) {
        var self = this;
        this.getRegion('sportkryss').show(new svs.sport.sportkryss.Sportkryss({
          model: this.options.coupon.get('hasSportkryssBet') ? this.options.coupon.get('sportkryssBet') : null,
          onSportkryssChanged: function onSportkryssChanged(bet) {
            self.options.coupon.updateSportkryss(bet);
          },
          toggleButtonCSSClass: 'sportkryss-btn-maltipset',
          helpDialogTitle: svs.maltipset.data.config.helpTexts.sportkryss.title,
          helpDialogBody: svs.maltipset.data.config.helpTexts.sportkryss.body
        }));
      }

      this.options.betslip.doResize();
    }
  },
  onDestroy: function onDestroy() {
    if (svs.components.marketplace && svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.onAccountChange)) ;
  },
  toggleOverviewBtn: function toggleOverviewBtn(e) {
    if (!svs.core.detect.formfactor.mobile()) {
      var textSpan = $(e.currentTarget).find('span');
      textSpan.text(textSpan.text() === 'Visa översikt av spelet' ? 'Dölj översikt av spelet' : 'Visa översikt av spelet');
    }
  },
  hideShowHuxflux: function hideShowHuxflux(value) {
    if (value === '0') {
      this.getRegion('sportkryss').currentView.ui.inputHolder.hide();
    } else {
      this.getRegion('sportkryss').currentView.ui.inputHolder.show();
    }
  },
  onRender: function onRender() {
    var self = this;
    this.getRegion('sportkryss').show(new svs.sport.sportkryss.Sportkryss({
      model: this.options.coupon.get('hasSportkryssBet') ? this.options.coupon.get('sportkryssBet') : null,
      onSportkryssChanged: function onSportkryssChanged(bet) {
        self.options.coupon.updateSportkryss(bet);
      },
      toggleButtonCSSClass: 'sportkryss-btn-maltipset',
      helpDialogTitle: svs.maltipset.data.config.helpTexts.sportkryss.title,
      helpDialogBody: svs.maltipset.data.config.helpTexts.sportkryss.body
    }));

    if (!(svs.components.marketplace && svs.components.marketplace.accountSelector.helpers.getCurrentAccount())) {
      this.getRegion('weeks').show(new svs.maltipset.views.BetslipContentWeeks({
        model: new svs.maltipset.models.Betslip({
          coupon: this.options.coupon
        })
      }));
    }

    setTimeout(function () {
      self.options.betslip.changeSize();
    }, 0);
  }
});
 })(window);